import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MaintenanceService } from '../services/maintenance.service'

@Component({
  selector: 'app-maintanance-notification',
  templateUrl: './maintanance-notification.component.html',
  styleUrls: ['./maintanance-notification.component.scss']
})

export class MaintananceNotificationComponent  {
  form!: FormGroup;
  notifications: any[] = [];
  Edit = false;
    Add = false;

  editIndex: number | null = null;

  constructor(private fb: FormBuilder ,private service:MaintenanceService) {
     this.form = this.fb.group({
            _id: [''],
      title: [''],
      status: ['active'],
    });
  }

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
  
    this.service.getAll().subscribe({
    next: (res: any) => {
      if (res.success) {
      this.notifications=res.result;
           this.Add = false;
       this.Edit=false;
      } else {
      }
    },
    error: err => {
      console.error(err);
    }
  });
}

  openForm(): void {
    this.form.reset({ status: 'active' });
    this.Add=true;
  }
  
  editForm(): void {
    this.form.reset({ status: 'active' });
      this.Edit=true;
    
  }


  cancelForm(): void {
    this.form.reset();
    this.getData();
  }

submitForm(): void {
  if (this.form.invalid) return;
  const payload = this.form.value;
  this.service.addData(payload).subscribe({
    next: (res: any) => {
      if (res.success) {

        this.getData();  
                window.location.reload();

      } else {
      }
    },
    error: err => {
      console.error(err);
    }
  });
}

UpdateForm(): void {
  if (this.form.invalid) return;
  const payload = this.form.value;
  this.service.updateData(payload).subscribe({
    next: (res: any) => {
      if (res.success) {
        this.getData(); 
     window.location.reload();

      } else {
      }
    },
    error: err => {
      console.error(err);
    }
  });
  this.getData();
}


editNotification(index: number): void {
  this.editIndex = index;
  const notif = this.notifications[index];
  // Bind data into the form, including _id for updates
  this.form.setValue({
    _id: notif._id || '',   // Assuming your data has _id field
    title: notif.title,
    status: notif.status
  });
  this.Edit = true;
}

deleteNotification(index: number): void {

  if (!confirm('Are you sure you want to delete this notification?')) {
    return;
  } 
  const notif = this.notifications[index];
  const reqData = { _id: notif._id };  // Prepare data for delete request

  this.service.delete(reqData).subscribe({
    next: (res: any) => {
      if (res.success) {
        window.location.reload();

        this.getData(); 
        
      } else {
      }
    },
    error: err => {
    }
  });
}


}
